// extracted by mini-css-extract-plugin
export default {"centerContent":"PrintableCpInfo_centerContent__TdkEY","scaleContent":"PrintableCpInfo_scaleContent__NG-2t"};